define('plugin/PluginsInitializer',['require','marionette','underscore','lib/plugin/PluginBroker','plugin/location/LocationPlugin','plugin/category/CategoryPlugin','plugin/group-booking/GroupBookingPlugin','plugin/additional-fields/AdditionalFieldsPlugin','plugin/multiple-booking/MultipleBookingPlugin','plugin/invoice/InvoicePlugin','plugin/promo/PromoPlugin','plugin/promotion/PromotionPlugin','plugin/deposit-paid-events/DepositPaidEventsPlugin','plugin/facebook/FacebookPlugin','plugin/news/NewsPlugin','plugin/gallery/GalleryPlugin','plugin/social-gallery/SocialGalleryPlugin','plugin/any-provider/AnyProviderPlugin','plugin/client-login/ClientLoginPlugin','plugin/client-field/ClientFieldPlugin','plugin/back-to-site/BackToSitePlugin','plugin/facebook-business/FacebookBusinessPlugin','plugin/membership/MembershipPlugin','plugin/package/PackagePlugin','plugin/secure/SecurePlugin','plugin/google-analytic/GoogleAnalyticPlugin','plugin/google-tag-manager/GoogleTagManagerPlugin','plugin/contact-widget/ContactWidgetPlugin','plugin/product/ProductPlugin','plugin/paid-attributes/PaidAttributesPlugin','plugin/classes/ClassesPlugin','plugin/user-license/UserLicensePlugin','plugin/static-page/StaticPagePlugin','plugin/google-translate/GoogleTranslatePlugin','plugin/kiosk/KioskPlugin','plugin/tickets/TicketsPlugin','plugin/pwa/PwaPlugin','plugin/telegram-notifications/TelegramNotificationsPlugin','plugin/facebook-pixel/FacebookPixelPlugin','plugin/waiting-list/WaitingListPlugin','plugin/bonus/BonusPlugin','plugin/google-reviews/GoogleReviewsPlugin','plugin/line-liff/LineLiffPlugin','plugin/tips/TipsPlugin','plugin/push-notifications/PushNotificationsPlugin','plugin/ai-booking/AiBookingPlugin','plugin/metricool/MetricoolPlugin'],function (require) {

	var Marionette = require('marionette');
	var _ = require('underscore'); // pin to Underscore: global window._ may be a lodash build that drops the _.each context arg
	var PluginBroker = require('lib/plugin/PluginBroker');
	var LocationPlugin = require('plugin/location/LocationPlugin');
	var CategoryPlugin = require('plugin/category/CategoryPlugin');
	var GroupBookingPlugin = require('plugin/group-booking/GroupBookingPlugin');
	var AdditionalFieldsPlugin = require('plugin/additional-fields/AdditionalFieldsPlugin');
    var MultipleBookingPlugin = require('plugin/multiple-booking/MultipleBookingPlugin');
	var PaidEventsPlugin = require('plugin/invoice/InvoicePlugin');//require('plugin/paid-events/PaidEventsPlugin');
    var PromoPlugin = require('plugin/promo/PromoPlugin');
    var PromotionPlugin = require('plugin/promotion/PromotionPlugin');
    var DepositPaidEventsPlugin = require('plugin/deposit-paid-events/DepositPaidEventsPlugin');
	var FacebookPlugin = require('plugin/facebook/FacebookPlugin');
	var NewsPlugin = require('plugin/news/NewsPlugin');
	var GalleryPlugin = require('plugin/gallery/GalleryPlugin');
	var SocialGalleryPlugin = require('plugin/social-gallery/SocialGalleryPlugin');
	var AnyProviderPlugin = require('plugin/any-provider/AnyProviderPlugin');
	var ClientLoginPlugin = require('plugin/client-login/ClientLoginPlugin');
	var ClientFieldPlugin = require('plugin/client-field/ClientFieldPlugin');
	var BackToSitePlugin = require('plugin/back-to-site/BackToSitePlugin');
	var FacebookBusiness = require('plugin/facebook-business/FacebookBusinessPlugin');
	var MembershipPlugin = require('plugin/membership/MembershipPlugin');
	var PackagePlugin = require('plugin/package/PackagePlugin');
    var SecurePlugin = require('plugin/secure/SecurePlugin');
    var GoogleAnalyticPlugin = require('plugin/google-analytic/GoogleAnalyticPlugin');
    var GoogleTagManagerPlugin = require('plugin/google-tag-manager/GoogleTagManagerPlugin');
    var ContactWidgetPlugin = require('plugin/contact-widget/ContactWidgetPlugin');
    var ProductPlugin = require('plugin/product/ProductPlugin');
    var PaidAttributesPlugin = require('plugin/paid-attributes/PaidAttributesPlugin');
    var ClassesPlugin = require('plugin/classes/ClassesPlugin');
    var UserLicensePlugin = require('plugin/user-license/UserLicensePlugin');
    var StaticPagePlugin = require('plugin/static-page/StaticPagePlugin');
    var GoogleTranslatePlugin = require('plugin/google-translate/GoogleTranslatePlugin');
    var KioskPlugin = require('plugin/kiosk/KioskPlugin');
    var TicketsPlugin = require('plugin/tickets/TicketsPlugin');
    var PwaPlugin = require('plugin/pwa/PwaPlugin');
    var TelegramNotificationsPlugin = require('plugin/telegram-notifications/TelegramNotificationsPlugin');
    var FacebookPixelPlugin = require('plugin/facebook-pixel/FacebookPixelPlugin');
    var WaitingListPlugin = require('plugin/waiting-list/WaitingListPlugin');
	var BonusPlugin = require('plugin/bonus/BonusPlugin');
	var GoogleReviewsPlugin = require('plugin/google-reviews/GoogleReviewsPlugin');
	var LineLiffPlugin = require('plugin/line-liff/LineLiffPlugin');
	var TipsPlugin = require('plugin/tips/TipsPlugin');
	var PushNotificationsPlugin = require('plugin/push-notifications/PushNotificationsPlugin');
    var AiBookingPlugin = require('plugin/ai-booking/AiBookingPlugin');
    var MetricoolPlugin = require('plugin/metricool/MetricoolPlugin');

	/**
	 * Class adds enabled plugins to plugin broker
	 *
	 * @class PluginsInitializer
	 */
	return Marionette.Object.extend({

		_availablePlugins: [],
		_defPlugins: {
			'push_notifications': PushNotificationsPlugin,
			'metricool': MetricoolPlugin
		},

		_pluginsMap: {
			'location': LocationPlugin,
			'event_category': CategoryPlugin,
			'group_booking': GroupBookingPlugin,
			'event_field': AdditionalFieldsPlugin,
            'multiple_booking': MultipleBookingPlugin,
			'paid_events': PaidEventsPlugin,
            'promo': PromoPlugin,
            'promotion': PromotionPlugin,
            'deposit_paid_events': DepositPaidEventsPlugin,
			'facebookImage': FacebookPlugin,
            'news': NewsPlugin,
            'gallery': GalleryPlugin,
            'social_gallery': SocialGalleryPlugin,
			'any_unit': AnyProviderPlugin,
			'client_login': ClientLoginPlugin,
			'client_field': ClientFieldPlugin,
			'back_to_site': BackToSitePlugin,
			'facebook_business': FacebookBusiness,
			'membership': MembershipPlugin,
			'package': PackagePlugin,
			'secure': SecurePlugin,
			'google_analytics': GoogleAnalyticPlugin,
			'google_tag_manager': GoogleTagManagerPlugin,
			'contact_widget': ContactWidgetPlugin,
			'product': ProductPlugin,
			'paid_attributes': PaidAttributesPlugin,
			'classes': ClassesPlugin,
			'user_license': UserLicensePlugin,
			'static_page': StaticPagePlugin,
			'google_translate': GoogleTranslatePlugin,
			'kiosk': KioskPlugin,
			'tickets': TicketsPlugin,
			'pwa': PwaPlugin,
			'tracking': FacebookPixelPlugin,
			'waiting_list': WaitingListPlugin,
			'telegram_notifications': TelegramNotificationsPlugin,
			'bonus_system': BonusPlugin,
			'google_reviews': GoogleReviewsPlugin,
			'line_liff': LineLiffPlugin,
			'tips': TipsPlugin,
            'ai_booking': AiBookingPlugin
		},

        _app: null,
		_clientModel: null,

		/**
		 * Inits instance
		 */
		initialize: function () {
			this._availablePlugins = this.getOption('plugins');
			this._app = this.getOption('app');
			this._clientModel = this.getOption('clientModel');
		},

		/**
		 * Init plugins and add them to PluginBroker
		 */
		initPlugins: function () {
			var pluginBroker = PluginBroker.getInstance();
			_.each(this._availablePlugins, function (plugin) {
				var pluginClass = this._pluginsMap[plugin];
				if (pluginClass) {
					pluginBroker.addPlugin(plugin, new pluginClass({
					    app: this._app,
						clientModel: this._clientModel
                    }));
				}
			}, this);

			_.each(this._defPlugins, function (plugin, name) {
				pluginBroker.addPlugin(name, new plugin({
				    app: this._app,
					clientModel: this._clientModel
				}));
			}, this);
		}

	});

});

